import { render, staticRenderFns } from "./TrancheDetails.vue?vue&type=template&id=c199bd14&scoped=true&"
import script from "./TrancheDetails.vue?vue&type=script&lang=js&"
export * from "./TrancheDetails.vue?vue&type=script&lang=js&"
import style0 from "./TrancheDetails.vue?vue&type=style&index=0&id=c199bd14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c199bd14",
  null
  
)

export default component.exports